import { useContext } from "react";
import { GlobalContext } from "../context/globalContext";
export const useConfig = () => {
  const { state } = useContext(GlobalContext);
  const { brand } = state;
  let wsValues = {};
  let url = `https://api.${brand}.es`;

  if (window.location.href.indexOf("dev.iframe") !== -1) {
    url = `https://dev.api.${brand}.es`;
  }
  if (window.location.href.indexOf("localhost") !== -1) {
    url = `https://dev.api.${brand}.es`;
  }

  wsValues = {
    wsBSIfinder: url + "/" + "/rest/BSIfinder-j.php?plate=",
    wsBSIpricesByModel: url + "/" + "/rest/v2/closedprice/bsi-prices-by-model.php",
    wsLicensePlate: url + "/" + "/rest/closedprice/plate_model.php?plate=",
    wsDealers: url + "/" + "/rest/closedprice/dealers.php",
    wsModels: url + "/" + "/rest/v2/closedprice/model.php",
    wsProducts: url + "/" + "/rest/closedprice/products-j.php?idconcesionario=null",
  };
  return wsValues;

  // }, []);
};
